
define('text!modules/reporting/campaigns/reachFrequency/templates/controls.html',[],function () { return '<div class="controls">\n  <strand-button type="secondary">\n    <label>Columns</label>\n  </strand-button>\n</div>\n<div class="column-selector-dialog no-display"></div>\n';});

